$(document).on('click', "#campeonatoGrupodiasPuedeReservarMarcarTodos", function () {
    var marcado = $("#campeonatoGrupodiasPuedeReservarMarcarTodos").is(':checked');
    $("#diasPuedereservar input").prop('checked', marcado);
});

/*Gestionar subgrupos*/
function dividirGrupoActualizaEstado(){
    $("#gruposDivididos .grupo").each(function (k, grupo) {
        $(grupo).find('.grupoInfo').removeClass('danger');
        var nEquiposActual = $(grupo).find('li').length;
        var nEquiposSubgrupo = parseInt($(grupo).find('.nEquiposSubgrupo').html());
        $(grupo).find('.nEquiposActual').html(nEquiposActual);
        if (nEquiposActual>nEquiposSubgrupo){
            $(grupo).find('.grupoInfo').addClass('danger');
        }
    });
}

$(document).on('click','.dividirGrupoAnyadirGrupo',function(){
       var grupo = $("#gruposDivididos > li:first-child").clone();
       $(grupo).find('.equipos').html('');
       $(grupo).find('.nombreGrupo').val($("#tituloGrupo").html()+' - '+Lang.get('msg.Nuevo'));
       $("#gruposDivididos").prepend(grupo);
        gruposMakeSortable();
        dividirGrupoActualizaEstado();
});

function gruposMakeSortable(){
    $(".dividirGrupoSortable .equipos").each(function (k, v) {
        $(v).sortable({
            // helper: "clone",
            appendTo:'body',
            helper: function (e, tr) {
                var $helper = tr.clone();
                var $helperCloned = $('<div/>').append($helper);
                var cloned = $('<div class="manage-groups" id="clone"><div class="dividirGrupoSortable llista"><ul>' + $helperCloned.html() + '</ul></div></div>');
                return cloned;
            },
            opacity: 1,
            items: "li:not(.ui-state-disabled)",
            cancel: ".ui-state-disabled",            
            connectWith: ".equipos",
            receive: function () {
                dividirGrupoActualizaEstado();
            }
        });
        $(v).disableSelection();
    });
}

$(document).on('click','.eliminaGrupo',function(){
        var grupo = $(this).closest('.grupo');
        var equipos = $(grupo).find('.equipos');
        $("#equiposSinAsignar .equipos").append(equipos.find('li').clone());
        $(grupo).remove();
});

function verPropuesta(opt){

    var editando = 0;
    if(typeof opt.editando!=='undefined')
        editando = opt.editando;
    var btnClicked = 0;
    if(typeof opt.btnClicked!=='undefined')
        btnClicked = opt.btnClicked;

    var data = {
        nEquiposGrupoactual : $("#nEquiposGrupoactual").val(),
        nEquiposSubgrupo: $("#nEquiposSubgrupo").val(),
        editando:editando,
        btnClicked:btnClicked
    }


    if (editando==1 && btnClicked==0){
        var url = '/api/campeonatoGrupo/'+$("#id_reg_campeonatos_grupo").val()+'/dividirVerPropuesta/editando';
    }else{
        var url = '/api/campeonatoGrupo/'+$("#id_reg_campeonatos_grupo").val()+'/dividirVerPropuesta';
    }


    $.post(url,data,function(res){
        $("#dividirGrupoRespuesta").html(res);
        gruposMakeSortable();
        dividirGrupoActualizaEstado();
    });
}

$(document).on('click','#verPropuestaBtn',function(){
    verPropuesta({editando:1,btnClicked:1});
});


$(document).on('click', '#dividirGrupoGuardarCambios', function () {
    var gruposConEquipos = new Array();
    $("#gruposDivididos li.llista").each(function (k, li) {
        var grupo = {
            'nombre': $(li).find('.nombreGrupo').val()
        }
        var equipos = new Array();
        $(li).find('.equipo').each(function (key, equipo) {
            equipos.push($(equipo).data('id_reg_equipos'));
        });
        grupo.equipos = equipos;
        gruposConEquipos.push(grupo);
    });

    var equiposSinAsignar = new Array();
    $("#equiposSinAsignar li.equipo").each(function (k, equipo) {
        equiposSinAsignar.push($(equipo).data('id_reg_equipos'));
    });

    var data = {
        'id_reg_campeonatos_grupo_original': $("#id_reg_campeonatos_grupo").val(),
        'gruposConEquipos': gruposConEquipos,
        'nEquiposSubgrupo':$("#nEquiposSubgrupo").val(),
        'editando':parseInt($("#page_dividirGrupoVerPropuesta #editando").val()),
        'equiposSinAsignar':equiposSinAsignar
    }
    $.post('api/campeonato_grupo/dividirGrupo', data, function (res) {
        process_response(res, false, $("#dividirResponse"));
    });
});

$(function(){
   if (parseInt($("#page_dividirGrupoVerPropuesta #editando").val())==1){
       verPropuesta({editando:1});
   }
});
/*gestionar subgrupos*/

/*Export to pdf*/

function kendoDomtoDrawing(containerWrap,pdfNombre,options){
    var multiPage = typeof options!== 'undefined' && typeof options.multiPage!=='undefined'?options.multiPage:false;
    var paperSize = typeof options!== 'undefined' && typeof options.paperSize!=='undefined'?options.paperSize:"auto";
    var landscape = typeof options!== 'undefined' && typeof options.landscape!=='undefined'?options.landscape:false;
    var bodyOldWidth = typeof options!== 'undefined' && typeof options.bodyOldWidth!=='undefined'?true:false;
    var margin = typeof options!== 'undefined' && typeof options.margin!=='undefined'?options.margin:{ left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" };
    //Multipage es faria servir en cas d'especificar un papersize diferent a 'auto'
    //El deixem a false, però el deixem aqui documentat per si més endavant es requeris true per alguna casuística concreta
    //multiPage = false;

    kendo.pdf.defineFont({
        "DejaVu Sans"             : "/fonts/kendo/DejaVuSans.ttf",
        "DejaVu Sans|Bold"        : "/fonts/kendo/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic" : "/fonts/kendo/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic"      : "/fonts/kendo/DejaVuSans-Oblique.ttf"
    });

    kendo.drawing.drawDOM(".pdfContainer",{
        multiPage: multiPage,
        paperSize: paperSize,
        landscape: landscape
    }).then(function(group) {
        return kendo.drawing.exportPDF(group,{
            margin: margin
        });
    })
        .done(function(data) {
            // Save the PDF file
            kendo.saveAs({
                dataURI: data,
                fileName: pdfNombre+'.pdf',
                proxyURL: "//demos.telerik.com/kendo-ui/service/export"
            });
            if (bodyOldWidth)
                $('body').width('auto');
            containerWrap.remove();
        });
}

function campeonatoGrupoExportPdfCategoriaQuadreLliga(e){
    var divQuadreLliga = e.closest('.quadre-lliga');
    var pdfNombre = $(e).data('pdf_nombre');
    var containerWrap = $('<div class="pdfContainer full-container campeonatoCategory"/>');
    containerWrap.append($(divQuadreLliga).html());
    containerWrap.find('.pdf_remove').remove();
    containerWrap.css({ height:2100});
    $('body').append(containerWrap);
    kendoDomtoDrawing(containerWrap,pdfNombre);
}

function campeonatoGrupoExportPdfVerCampeonatoLiga(e){
    var pdfNombre = $(e).data('pdf_nombre');
    var containerWrap = $('<div class="pdfContainer full-container"/>');
    var campeonatoGrupo = $(e).closest('.campeonatoGrupo');
    // Hem de diferencia quan fem el PDF des de resum general o amb un grup seleccionat
    if (campeonatoGrupo.length === 1) {
        var titulo = campeonatoGrupo.find('.quadre-lliga').find('.title');
        containerWrap.append($(titulo).html());
        containerWrap.append($(campeonatoGrupo).find('.pagepdf').html());
    } else {
        containerWrap.append($('.title').html());
        containerWrap.append($('.pagepdf').html());
    }
    containerWrap.find('.pdf_remove').remove();
    $('body').append(containerWrap);
    kendoDomtoDrawing(containerWrap,pdfNombre);
}

function campeonatoGrupoExportPdfCategoriaJornadas(e){

    var pdfNombre = $(e).data('pdf_nombre');
    var containerWrap = $('<div class="pdfContainer full-container campeonatoCategory"/>');
    var campeonatoGrupo = $(e).closest('.campeonatoGrupo');
    var titulo = campeonatoGrupo.find('.quadre-lliga').find('.title');
    containerWrap.append($(titulo).html());
    containerWrap.append($(campeonatoGrupo).find('.puntuacionpartidos').html());
    $(containerWrap).find('.ronda').each(function(key,ronda){
            $(ronda).after('<div class="clearfix"/>');
    });
    containerWrap.find('.pdf_remove').remove();
    $('body').append(containerWrap);

    var options = { //Ho fem múltiPàgina perquè hi poden haver moltíssimes jornades (i tot en una pàgina queda petitíssim)
        multiPage : true,
        paperSize: "A4",
        //landscape:true,
        margin: { left: "1cm", top: "0cm", right: "1cm", bottom: "0cm" }
    }

    kendoDomtoDrawing(containerWrap,pdfNombre, options);
}

function campeonatoGrupoExportPdfVerCampeonatoEliminatoria(e){
    var pdfNombre = $(e).data('pdf_nombre');
    var containerWrap = $('<div id="pdfContainer" class="pdfContainer full-container campeonatoCategory"/>');
    containerWrap.append( $('.compartir_page').html());
    containerWrap.find('.pdf_remove').remove();
    containerWrap.find('.fer_reserva_btn').remove();
    containerWrap.find('.editar_puntuacions_btn').remove();
    containerWrap.find('.dropdown-toggle').remove();
    containerWrap.find('.rondes').attr('id','rondes_cloned');
    $('body').append(containerWrap);

    var elmnt = document.getElementById("rondes_cloned");
    $('body').width(elmnt.scrollWidth);
    var options = {
        multiPage : true,
        margin: { left: "2cm", top: "2cm", right: "2cm", bottom: "2cm" },
        bodyOldWidth: true
    }
    kendoDomtoDrawing(containerWrap,pdfNombre,options);
    // Convert the DOM element to a drawing using kendo.drawing.drawDOM
}

function campeonatoGrupoBuscarPartido(e){

    var pdfNombre = $(e).data('pdf_nombre');
    var containerWrap = $('<div id="pdfContainer" class="pdfContainer full-container campeonatoCategory"/>');
    containerWrap.append( $('#buscarPartidoModal .modal-body').html());
    var buscador = $(containerWrap).find('#partidosListaBuscadorFormGroup');
    var buscador_texto = $('#partidosListaBuscador').val();
    if (buscador_texto!=='')
    {
        containerWrap.prepend('<p><b>'+Lang.get('msg.Filtro')+': </b>'+buscador_texto+'</p>');
    }
    $(buscador).remove();

    containerWrap.find('.pdf_remove').remove();
    $('body').append(containerWrap);
    kendoDomtoDrawing(containerWrap,pdfNombre);

}

function campeonatoGrupoExportarPDFSegunTipo(e, pdf_tipo){
    var divToFind = e.closest('.' + pdf_tipo);
    var pdfNombre = pdf_tipo + '-' +$(e).data('pdf_nombre');
    var containerWrap = $('<div class="pdfContainer full-container"/>');
    containerWrap.append($(divToFind).html());
    containerWrap.find('.pdf_remove').remove();
    //containerWrap.css({ height:2100});
    $('body').append(containerWrap);
    kendoDomtoDrawing(containerWrap,pdfNombre);
}

$(document).on('click','.campeonatoGrupoBtnExportPdf',function(ev){
    switch ($(this).data('pdf_tipo')){
        case 'categoria-quadre-lliga':
            campeonatoGrupoExportPdfCategoriaQuadreLliga($(this));
            break;
        case 'ver-campeonato-liga':
            campeonatoGrupoExportPdfVerCampeonatoLiga($(this));
            break;
        case 'categoria_jornadas':
            campeonatoGrupoExportPdfCategoriaJornadas($(this));
            break;
        case 'ver-campeonato-eliminatoria':
            campeonatoGrupoExportPdfVerCampeonatoEliminatoria($(this));
            break;
        case 'campeonato-buscar-partido':
            campeonatoGrupoBuscarPartido($(this));
            break;
        case 'inscripcion':
            campeonatoGrupoExportarPDFSegunTipo($(this),'inscripcion');
            break;
        default:

    }
    ev.preventDefault();
    ev.stopPropagation();
    $(".compartir").removeClass('open');
});

function closeCompartirDropdown(){
    $(".compartir").removeClass('open');
}

/*Export to pdf*/

/*Activar pago
 **************************/
$(document).on('switchChange.bootstrapSwitch','#activarPagoCheckbox', function (event, state) {
    $("#activarPagoDiv .tiposIngresoPrecios").toggleClass('hidden');
});

var activarPago = {
    reenumerarPrecios : function(contenedor){
        contenedor.find('.precio').each(function (k, v) {
            $(this).find('.inputTiposocio').attr('name', 'precios[' + k + '][tiposocio]');
            $(this).find('.inputImporte').attr('name', 'precios[' + k + '][importe]');
        });
    },
    anadirPrecio: function (objeto){
        var contenedor = objeto.contenedor;
        var precio = 0;
        var todos = 0;
        if (typeof objeto.precio!=='undefined')
            precio = objeto.precio;
        if (typeof objeto.todos!=='undefined' && objeto.todos==1)
            todos = 1;



        var options = '';
        var tiposocios = JSON.parse($("#tiposocios").val());

        var eliminaPrecio = '';

        //Si es el 1r registro de precios, no lo permitiremos eliminar, y solo aparecerá el tipousuario Todos
        if(contenedor.find('.precio').length>0){
            eliminaPrecio = '<div class="col-xs-1"><i class="fa fa-minus-square red pointer APeliminaPrecio"></i></div>';
            tiposocios.splice(0, 1);
        }else{
            tiposocios = tiposocios[0];
        }

        $(tiposocios).each(function(k,e){
            var selected = '';
            if (typeof objeto.id_mst_tiposocio!=='undefined' && e.value== objeto.id_mst_tiposocio)
                selected = 'selected';

            options += '<option '+selected+' value="'+e.value+'">'+e.text+'</option>';
        });

        var selectorTiposocios = '' +
            '<select name="precios[][tiposocio]" style="margin-top:5px" class="form-control input-sm inputTiposocio">'+options+'</select>' +
            '';


        var precio = $(
            '<div class="row precio" data-numeracion = "">' +
            '<div class="col-xs-6">'+selectorTiposocios+'</div>' +
            '<div class=col-xs-4><input class="form-control input-sm inputImporte" type="text" name="precios[][importe]" value="'+precio+'" placeholder="'+Lang.get('frm.Importe')+'"/></div>' +
            eliminaPrecio +
            '</div>'
        );
        contenedor.append(precio);
        activarPago.reenumerarPrecios(contenedor);
    }
}


$(document).on('click', ".APeliminaPrecio", function () {
    $(this).closest('.precio').remove();
    activarPago.reenumerarPrecios($("#APprecios"));
});

$(document).on('click', ".APanadirPrecioBtn", function () {
    activarPago.anadirPrecio({'contenedor': $('#APprecios')});
});

var campeonato_grupo = {
    calcular_precio_reserva:{
        comprobar: function(){
            var calcular_precio_factura = $("#calcular_precio_factura").val();
            if (calcular_precio_factura=='0'){
                $(".id_mst_tipoingreso.form-group").addClass('hidden');
            }else{
                $(".id_mst_tipoingreso.form-group").removeClass('hidden');
            }
        }
    },
    especificar_nombres:{
        comprobar:function(){
            if (parseInt($("[name=entre_clubs_especificar_nombres]:checked").val())==1)
                $("#campeonatoGrupoNombrePartidos").removeClass('hidden');
            else
                $("#campeonatoGrupoNombrePartidos").addClass('hidden');
        }
    },
    editar:{
        entre_clubs:{
            minimo_participantes:{
                comprobar:function(){
                    $("[name=campeonato_grupo_minimo_participantes_especificar]:checked").val()>0?$("[name=campeonato_grupo_entre_clubs_minimo_participantes]").removeClass('hidden'):$("[name=campeonato_grupo_entre_clubs_minimo_participantes]").addClass('hidden');
                }
            },
            maximo_participantes:{
                comprobar:function(){
                    $("[name=campeonato_grupo_maximo_participantes_especificar]:checked").val()>0?$("[name=campeonato_grupo_entre_clubs_maximo_participantes]").removeClass('hidden'):$("[name=campeonato_grupo_entre_clubs_maximo_participantes]").addClass('hidden');
                }
            },
            especificar_nombre:{
                comprobar:function(){
                    $("[name=entre_clubs_npartidos_especificar]:checked").val()>0?$("[name=entre_clubs_npartidos]").removeClass('hidden'):$("[name=entre_clubs_npartidos]").addClass('hidden');
                }
            }
        }
    },
    canaria: {
        generar_jornada_siguiente: function(id_reg_campeonatos_grupo){
            axios.post('/api/campeonato/canarias/campeonatos_grupo/'+id_reg_campeonatos_grupo+'/generar_siguiente_jornada').then(function(res){
                ligaConPartidos.vue.cargarPartidos({
                    ronda:res.data.ronda,
                    cargar_clasificacion:0
                });
                setTimeout(function(){
                    $("#generar_jornada_siguiente_btn").notify(
                        res.data.msg,
                        {position: "top", className: res.data.error==1?'error':'success'}
                    );
                },300);

            });
        }
        // generar_siguiente_jornada_btn
    }

}


$(document).on('click','[name=entre_clubs_especificar_nombres]',campeonato_grupo.especificar_nombres.comprobar);
$(document).on('click','[name=campeonato_grupo_minimo_participantes_especificar]',campeonato_grupo.editar.entre_clubs.minimo_participantes.comprobar);
$(document).on('click','[name=campeonato_grupo_maximo_participantes_especificar]',campeonato_grupo.editar.entre_clubs.maximo_participantes.comprobar);
$(document).on('click','[name=entre_clubs_npartidos_especificar]',campeonato_grupo.editar.entre_clubs.especificar_nombre.comprobar);
$(document).on('change', "#calcular_precio_factura", function () {
    campeonato_grupo.calcular_precio_reserva.comprobar();      
});


function add_championship_callback(data){
    var data = data.data;
    if (typeof data.activar_pago!=='undefined' && data.activar_pago==1){
        var form = '' +
            '<form id="campeonatoGrupoRedirectViewPaymentForm" method="POST" action="/viewPaymentForm">' +
            '<input type="hidden" name="id_reg_campeonatos_grupo" value="'+data.id_reg_campeonatos_grupo+'" />' +
            '<input type="hidden" name="id_reg_equipos" value="'+data.id_reg_equipos+'" />' +
            '<input type="hidden" name="_token" value="'+$("[name=csrf_token]").attr('content')+'"/>' +
            '<input id="pago_bizum_"' + data.id_reg_equipos +'" type="hidden" name="pago_bizum" value="' + data.pago_bizum +'"/>' +
            '</form>'
        $(".cal_campeonatos").append(form);
        $(".cal_campeonatos #campeonatoGrupoRedirectViewPaymentForm").submit();
    }
}